import { Directive } from '@angular/core';
@Directive({
  selector: '[fSearchContainer]'
})
export class SearchContainerDirective {}
